// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconBoldEdit = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '25',
      height: '24',
      viewBox: '0 0 25 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.5 22H3.5C3.09 22 2.75 21.66 2.75 21.25C2.75 20.84 3.09 20.5 3.5 20.5H21.5C21.91 20.5 22.25 20.84 22.25 21.25C22.25 21.66 21.91 22 21.5 22Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.5206 3.48162C17.5806 1.54162 15.6806 1.49162 13.6906 3.48162L12.4806 4.69162C12.3806 4.79162 12.3406 4.95162 12.3806 5.09162C13.1406 7.74162 15.2606 9.86162 17.9106 10.6216C17.9506 10.6316 17.9906 10.6416 18.0306 10.6416C18.1406 10.6416 18.2406 10.6016 18.3206 10.5216L19.5206 9.31162C20.5106 8.33162 20.9906 7.38162 20.9906 6.42162C21.0006 5.43162 20.5206 4.47162 19.5206 3.48162Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.1103 11.5309C15.8203 11.3909 15.5403 11.2509 15.2703 11.0909C15.0503 10.9609 14.8403 10.8209 14.6303 10.6709C14.4603 10.5609 14.2603 10.4009 14.0703 10.2409C14.0503 10.2309 13.9803 10.1709 13.9003 10.0909C13.5703 9.81086 13.2003 9.45086 12.8703 9.05086C12.8403 9.03086 12.7903 8.96086 12.7203 8.87086C12.6203 8.75086 12.4503 8.55086 12.3003 8.32086C12.1803 8.17086 12.0403 7.95086 11.9103 7.73086C11.7503 7.46086 11.6103 7.19086 11.4703 6.91086C11.4491 6.86547 11.4286 6.8203 11.4088 6.7754C11.2612 6.44208 10.8265 6.34463 10.5688 6.60239L4.84032 12.3309C4.71032 12.4609 4.59032 12.7109 4.56032 12.8809L4.02032 16.7109C3.92032 17.3909 4.11032 18.0309 4.53032 18.4609C4.89032 18.8109 5.39032 19.0009 5.93032 19.0009C6.05032 19.0009 6.17032 18.9909 6.29032 18.9709L10.1303 18.4309C10.3103 18.4009 10.5603 18.2809 10.6803 18.1509L16.4016 12.4296C16.6612 12.17 16.5633 11.7246 16.2257 11.5805C16.1877 11.5643 16.1492 11.5477 16.1103 11.5309Z',
      fill: 'currentColor',
    }),
  );

export { IconBoldEdit };
